export default __webpack_public_path__ + "static/media/Erwin.692ef69f.png";